import React, { useEffect, useState } from "react";
import cn from 'classnames';

//@ts-ignore
import styles from "./style.module.scss";

interface GeneratingLoadingProps {
  loading: boolean;
  title?: string;
  text?: string;
}

const GeneratingLoading = ({
  loading,
  title,
  text,
}: GeneratingLoadingProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    let interval: number | undefined;

    if (loading) {
      setActiveIndex(0);
      interval = window.setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % 4);
      }, 800);
    }

    return () => {
      if (interval !== undefined) {
        window.clearInterval(interval);
      }
    };
  }, [loading]);

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingCard}>
        <div className={styles.progressDots}>
          {[0, 1, 2, 3].map((index) => (
            <div
              key={index}
              aria-hidden="true"
              className={cn(
                styles.progressDot,
                {
                  [styles.active]: index <= activeIndex,
                  [styles.current]: index === activeIndex,
                },
                styles[`dot${index + 1}`]
              )}
            />
          ))}
        </div>

        <h1 className={styles.loadingTitle}>
          {title || "Generating Project Plan"}
        </h1>

        <p className={styles.loadingText}>
          {text || "Please wait while we prepare your plan"}
        </p>
      </div>
    </div>
  );
};

export default GeneratingLoading;
